// Libs
import React, { useEffect, useMemo, useState } from 'react';
import { Modal, Tooltip } from 'antd';
import moment from 'moment';

// Own Libs
import * as ui from '@digital/ui';

//Api
import {
  deleteAnexoPecaOrcamentaria,
  downloadAnexoDemandaPecaOrcamentaria,
  getAnexosPecaOrcamentaria
} from '@app/api/demanda';

//Files
import { UploadMultProps } from '@app/components';

//Utils
import { dateTimeFormat } from '@app/helpers/dateTimeFormats';
import { EStatusDemanda } from '@app/enums/EStatusDemanda';
import { usuarioLogadoState } from '@app/atoms';
import { useRecoilValue } from 'recoil';

interface PropsModal {
  demandaId: string;
  statusCodigo: number;
}

const ModalIncluirAnexoPecaOrcamentaria = ({ demandaId, statusCodigo }: PropsModal) => {
  const [exibirModal, setExibirModal] = useState(false);
  const [updateAnexos, setUpdateAnexos] = useState(true);
  const [data, setData] = useState([]);
  const [descricao, setDescricao] = useState('');

  const usuarioLogado = useRecoilValue(usuarioLogadoState);

  const disabled = 
    [
      EStatusDemanda.AguardandoAnaliseControladoria,
      EStatusDemanda.AguardandoAnaliseControladoriaModificacao,
      EStatusDemanda.AguardandoAnaliseControladoriaReavaliacao,
    ].includes(statusCodigo) === false;

  const onUpdateAnexos = () => {
    setUpdateAnexos(!updateAnexos);
  };

  const handleCancel = () => {
    setExibirModal(false);
  };

  const getAnexos = () => {
    getAnexosPecaOrcamentaria(demandaId).then((response: any) => {
      setData(response);
    });
  };

  useEffect(() => {
    getAnexos();
  }, [updateAnexos]);

  useEffect(() => {
    onUpdateAnexos();
  }, []);

  const handleExcluir = (arquivoId: string) => {
    deleteAnexoPecaOrcamentaria(arquivoId)
      .then(() => {
        onUpdateAnexos();
      });
  };

  const columns = () => {
    const columns: ui.ColumnProps<any>[] = [];

    columns.push({ title: 'Nome', dataIndex: 'nome' });

    columns.push({
      title: 'Inclusão',
      dataIndex: 'dataInclusao',
      width: '15%',
      render: (text, record) => moment(record.dataInclusao).format(dateTimeFormat),
    });

    columns.push({
      title: 'ações',
      dataIndex: 'acoes',
      width: '10%',
      render: (text, record) => (
        <>
          <UploadMultProps
            idDoComponente={`mrn-button-ModalIncluirAnexoPecaOrcamentaria-upload-${record.id}`}
            tooltip={'Substituir Arquivo'}
            enderecoApi={`anexoDemanda/PecaOrcamentaria/upload`}
            listUploadPropsForm={[{ key: 'anexoId', value: record.id }]}
            showLabel={false}
            retorno={data => {
              onUpdateAnexos();
            }}
          />

          <Tooltip title="Download Arquivo">
            <ui.Button
              icon="ui-download"
              type="link"
              onClick={() => {
                downloadAnexoDemandaPecaOrcamentaria(record.id, record.nome);
              }}
              id={`mrn-button-ModalIncluirAnexoPecaOrcamentaria-download-${record.id}`}
            />
          </Tooltip>

          <Tooltip title="Excluir">
            <ui.Button
              icon="science-minus"
              type="link"
              title=""
              onClick={() => {
                handleExcluir(record.id);
              }}
              id={`mrn-button-modal-anexo-peca-orcamentaria-excluir-${record.id}`}
            />
          </Tooltip>
        </>
      ),
    });

    return columns;
  };


  return (
    <>
      <Tooltip title="Incluir Anexo">
        <ui.Button
          type="link"
          size='small'
          onClick={() => {
            onUpdateAnexos();
            setExibirModal(true);
          }}
          icon="ui-upload"
          className={data && data.length > 0 && data.some((s: any) => s.responsavel != usuarioLogado.nome) ? 'has-comments' : ''}
          disabled={disabled}
          id="mrn-button-modal-anexo-peca-orcamentaria-incluir-anexo"
        />
      </Tooltip>

      {exibirModal && (
        <Modal
          title="ANEXO"
          width="980px"
          visible={exibirModal}
          onCancel={handleCancel}
          footer={[
            <ui.Button key="close" type="link" onClick={() => handleCancel()}>
              Fechar
            </ui.Button>,
          ]}>
          <ui.MasterDetailForm>
            <ui.Widget>
              <ui.Row>
                <span>Incluir abaixo os arquivos referentes à Previsão Orçamentária</span>
              </ui.Row>
              <ui.Row>
                <ui.Table rowKey="id" columns={columns()} dataSource={data} pagination={false} />
              </ui.Row>
              <ui.Row style={{ float: 'right' }}>
                {/* <ui.FormInput
                  name="descricaoDocumento"
                  label="Descrição do Documento"
                  span={12}
                  required
                  value={descricao}
                  onChange={e => setDescricao(e.target.value)}
                /> */}
                <UploadMultProps
                  idDoComponente={`mrn-button-ModalIncluirAnexoPecaOrcamentaria-upload-incluir`}
                  tooltip={'Incluir Arquivo'}
                  listUploadPropsForm={[
                    { key: 'demandaId', value: demandaId },
                    // { key: 'descricaoDocumento', value: descricao },
                  ]}
                  enderecoApi={`anexoDemanda/PecaOrcamentaria/upload`}
                  iconName={'ui-upload'}
                  hasFile={false}
                  label="INCLUIR ANEXO"
                  buttonClass="ant-btn-primary"
                  retorno={data => {
                    onUpdateAnexos();
                  }}
                />
              </ui.Row>
            </ui.Widget>
          </ui.MasterDetailForm>
        </Modal>
      )}
    </>
  );
};
export default ModalIncluirAnexoPecaOrcamentaria;
